import { ref, inject, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { store } from "../store";
import Segments from "./Segments";
import { trackPixel } from "./Pixel";
import * as SmartySDK from "smartystreets-javascript-sdk";

const SmartyCore = SmartySDK.core;
const websiteKey = "115379242330163169";
const smartySharedCredentials = new SmartyCore.SharedCredentials(websiteKey);
const autoCompleteClientBuilder = new SmartyCore.ClientBuilder(
  smartySharedCredentials,
);
const autoCompleteClient = autoCompleteClientBuilder.buildUsAutocompleteProClient();
const { OrderCompleted, OrderCompletedTS } = Segments();

export default function Account(flagFrom) {
  // let fileUrl;
  const axios = inject("axios");

  const orders = reactive({
    loading: false,
    data: [],
    overdue: false,
    self_pay: false,
    company_id: null,
    error: "",
    balance_total: null,
    open_invoices_count: null,
    overdue_amount: null,
    overdue_count: null,
    next_due_date: null,
    next_due_order_number: null,
    oldest_overdue_days: null,
    locations: [],
    locations_with_balance: [],
    status_counts: {},
    payment_counts: {},
    total_count: null,
    customer_since: null,
  });

  const reOrderdetails = reactive({
    loading: false,
    data: [],
    error: "",
  });

  const users = reactive({
    loading: false,
    data: [],
    activeUser: "",
    error: "",
  });

  const address = reactive({
    loading: false,
    data: [],
    error: "",
    address_id: "",
    licenses: [],
  });
  const addresses = reactive({
    loading: false,
    data: [],
    suggestions: [],
    error: "",
  });
  const editadd = reactive({
    loading: false,
    data: [],
    addId: "",
    error: "",
  });

  const st = reactive({
    loading: false,
    data: [],
    error: "",
  });

  const zipcode = reactive({
    loading: false,
    data: [],
    error: "",
  });
  const invoice = reactive({
    loading: false,
    data: [],
    error: "",
  });

  const packingList = reactive({
    loading: false,
    data: [],
    error: "",
  });

  const orderdetails = reactive({
    loading: false,
    data: [],
    error: "",
  });

  const loader = ref(false);

  const router = useRouter();
  const route = useRoute();
  const getAddress = async () => {
    addresses.data = [];
    addresses.loading = true;
    axios.authApi
      .get("/addresses")
      .then((resp) => {
        if (resp.status) {
          store.dispatch("setAddresses", resp.data.data);
          addresses.data = resp.data.data;
        } else {
          addresses.error = resp.data.error;
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (addresses.loading = false));
  };
  const getOrders = (pg = 1, filters = {}) => {
    orders.loading = true;
    const params = { page: pg };
    if (filters.q) params.q = filters.q;
    if (filters.status && filters.status !== "all") params.status = filters.status;
    if (filters.payment && filters.payment !== "all") params.payment = filters.payment;
    if (filters.location && filters.location !== "all") params.location = filters.location;
    if (filters.b_location && filters.b_location !== "all") params.b_location = filters.b_location;
    if (filters.date_from) params.date_from = filters.date_from;
    if (filters.date_to) params.date_to = filters.date_to;
    if (filters.per_page) params.per_page = Number(filters.per_page);
    axios.authApi
      .get("/account/orders", { params })
      .then((resp) => {
        if (resp.data.status) {
          orders.data = resp.data.data;
          orders.self_pay = resp.data.self_pay;
          orders.company_id = resp.data.company_id;
          // summary card
          const summary = resp.data.summary || {};
          orders.balance_total = summary.total_balance ?? null;
          orders.open_invoices_count = summary.open_invoice_count ?? null;
          orders.overdue_amount = summary.overdue_amount ?? null;
          orders.overdue_count = summary.overdue_count ?? null;
          orders.next_due_date = summary.next_due_at ?? null;
          orders.next_due_order_number = summary.next_due_order ?? null;
          orders.oldest_overdue_days = summary.oldest_overdue_days ?? null;
          orders.overdue = !!(summary.overdue_count && summary.overdue_count > 0);
          // status counts
          orders.status_counts = resp.data.counts ?? {};
          orders.total_count = resp.data.counts?.all ?? null;
          orders.payment_counts = resp.data.payment_counts ?? {};
          // locations list
          orders.locations = resp.data.locations ?? [];
          orders.locations_with_balance = resp.data.locations_with_balance ?? [];
          orders.customer_since = resp.data.customer_since ?? null;
        } else {
          orders.error = resp.data.error || "Failed to load orders";
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (orders.loading = false));
  };

  const addAddress = (label, address = []) => {
    axios.authApi
      .post("/account/create-address", {
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        nickname: address.nickname,
        state:
          typeof address.state == "string"
            ? address.state
            : address.state.state,
        zip_code: typeof address.zip_code
          ? address.zip_code
          : address.zip_code.zip_code,
        label: label ? label : address.label ? address.label.shipping : null,
      })
      .then((resp) => {
        if (resp.status) {
          address.data = resp.data;
          address.address_id = address.data.data.address.id;
          address.licenses = address.data.data.licenses;
          getAddress();
        } else {
          address.error = resp.data.error;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const editAddress = async (id) => {
    await axios.authApi
      .get("/account/edit-address/" + id)
      .then((resp) => {
        if (resp.status) {
          editadd.data = resp.data.data;
          editadd.addId = editadd.data.address.id;
        } else {
          editadd.error = resp.data.error;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteAddress = (id) => {
    axios.authApi
      .get("/account/delete-address/" + id)
      .then((resp) => {
        if (resp.status) {
          address.data = resp.data.data;
          getAddress();
        } else {
          address.error = resp.data.error;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getStates = () => {
    st.loading = true;
    axios.api
      .get("/get-states")
      .then((resp) => {
        if (resp.status) {
          st.data = resp.data.data;
        } else {
          st.error = resp.data.error;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getZipcodes = (states, query) => {
    zipcode.loading = true;
    axios.authApi
      .get("/zip-codes", {
        params: {
          state: states,
          q: query,
        },
      })
      .then((resp) => {
        if (resp.status) {
          zipcode.data = resp.data.data;
        } else {
          zipcode.error = resp.data.error;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getUsers = async () => {
    users.loading = true;
    await axios.authApi
      .get("/account/users")
      .then((resp) => {
        if (resp.status) {
          users.data = resp.data.data;
          users.activeUser = resp.data.data.users.filter((r) => r.loggedIn)[0];
        } else {
          users.error = resp.data.error;
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (users.loading = false));
  };

  const getOrderdetails = () => {
    orderdetails.loading = true;
    let id = route.params.id;
    axios.authApi
      .get("/account/order-details/" + id)
      .then((resp) => {
        if (resp.data.status) {
          orderdetails.data = resp.data;
          if (flagFrom) {
            OrderCompleted(orderdetails.data.data, store.getters.cart);
            OrderCompletedTS(orderdetails.data.data);
            trackPixel('Purchase', {
              value: Number(orderdetails.data.data.orderTotal),
              currency: 'USD',
              content_type: 'product',
              content_ids: (orderdetails.data.data.order_line_items || []).map(i => i.variantId || i.productId)
            });

            if (orderdetails.data.data.request_id) {
              const url = "https://backend.perseuss.xyz/post-live-rate-webhook";
              const headers = {
                "Content-Type": "application/json",
              };

              const data = {
                api_key: "MEDUSA_HxKIzMAdF61Tw29A@5QeB",
                medusa_order_id: orderdetails.data.data.order_number,
                live_rate_request_id: orderdetails.data.data.request_id,
              };

              fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
              })
                .then((response) => response.json())
                .then((data) => console.log(data))
                .catch((error) => console.error("Error:", error));
            }
          }
          orderdetails.loading = false;
        } else {
          // Redirect to 404 when order not found
          router.push({ name: "404" });
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (orderdetails.loading = false));
  };
  const Invoice = () => {
    invoice.loading = true;
    let id = route.params.id;
    axios.api
      .get("/invoice/" + id)
      .then((resp) => {
        if (resp.status) {
          invoice.data = resp.data;
          invoice.loading = false;
        } else {
          invoice.error = resp.data.error;
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (invoice.loading = false));
  };

  const PackingList = () => {
    packingList.loading = true;
    let id = route.params.id;
    axios.authApi
      .get(
        "/packing-list/" +
          id +
          (route.params.shipment_id ? "/" + route.params.shipment_id : ""),
      )
      .then((resp) => {
        if (resp.status) {
          packingList.data = resp.data;
        } else {
          packingList.error = resp.data.error;
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (packingList.loading = false));
  };

  const getReOrderDetails = () => {
    reOrderdetails.loading = true;
    let id = route.params.id;
    axios.authApi
      .get("/reorder/" + id)
      .then((resp) => {
        if (resp.status) {
          reOrderdetails.data = resp.data;
        } else {
          reOrderdetails.error = resp.data.error;
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (reOrderdetails.loading = false));
  };

  const buildInvoiceFilename = (invoice) => {
    const company = invoice.company?.name || "";
    const nickname = invoice.shipping_address?.nickname || "";
    const inv = invoice.invoice_number;

    let label;
    if (!nickname) {
      label = company;
    } else if (nickname.includes(company)) {
      label = nickname;
    } else {
      label = company ? `${company} - ${nickname}` : nickname;
    }

    const raw = `${label} - Inv ${inv}`;
    return raw.replace(/[/\\:*?"<>|]/g, "-").replace(/\s{2,}/g, " ").trim() + ".pdf";
  };

  const downloadInvoice = async (invoice) => {
    loader.value = true;
    await axios.api
      .get("/download-invoice/" + invoice.id, {
        responseType: "blob", // Set the response type to 'blob'
      })
      .then((resp) => {
        let filename = buildInvoiceFilename(invoice);
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up after download
        window.URL.revokeObjectURL(url); // Release the URL object after download

        loader.value = false;
      })
      .catch((error) => {
        console.error("Error downloading the invoice:", error);
      });
  };

  // Fetch open invoices based on the invoice number from the route query
  const invoices = ref([]);
  const isInvoicesLoading = ref(false);
  const getInvoices = () => {
    isInvoicesLoading.value = true;
    axios.api
      .get(
        "invoice-payments/" +
          route.params.company_id +
          "/" +
          (route.params.invoice_number || ""),
      )
      .then((resp) => {
        if (resp.status) {
          invoices.value = resp.data.data;
          // invoices.value.forEach((invoice) => {
          //   invoice.is_invoice = false;
          // });

          //  invoices.value.cards = invoices.value.cards.filter(i => i.customer_vault_id == '1233130145')
          // console.log("Invoices:", invoices*.value);
        } else {
          console.error(resp.data.error);
        }
      })
      .catch((error) => {
        console.error("Error fetching invoices:", error);
      })
      .finally(() => {
        isInvoicesLoading.value = false;
      });
  };

  const getCreditCards = async () => {
    await axios.authApi
      .get("/credit-cards")
      .then((resp) => {
        if (resp.status) {
          invoices.value.cards = resp.data.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const downloadStatementLoader = reactive({ loading: false });
  const downloadStatement = () => {
    downloadStatementLoader.loading = true;

    axios.authApi
      .get("/selected/customer_statement_pdf", {
        baseURL: "https://nexus-api.medusadistribution.com/api",
        responseType: "blob",
        params: {
          company: localStorage.getItem("company_id"),
          download: true,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          const today = new Date();
          const formattedDate =
            String(today.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(today.getDate()).padStart(2, "0") +
            "-" +
            today.getFullYear();

          const file_name = `${localStorage.getItem(
            "company_name",
          )} Statement ${formattedDate}.pdf`;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file_name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error("Failed to download statement:", response.data.error);
        }
        downloadStatementLoader.loading = false;
      })
      .catch((error) => {
        downloadStatementLoader.loading = false;
        console.error("Error downloading statement:", error);
      });
  };

  const queryAutocompleteForSuggestion = (query) => {
    const lookup = new SmartySDK.usAutocompletePro.Lookup(query);
    addresses.suggestions = [];

    autoCompleteClient
      .send(lookup)
      .then((response) => {
        response.result.forEach((suggestion) => {
          const secondary =
            suggestion.secondary && suggestion.secondary !== "#"
              ? ` ${suggestion.secondary}`
              : "";
          addresses.suggestions.push({
            suggestion: suggestion,
            address:
              suggestion.streetLine +
              secondary +
              " " +
              suggestion.city +
              ", " +
              suggestion.state +
              " " +
              suggestion.zipcode,
          });
        });
      })
      .catch((e) => console.log(e.error));
  };

  return {
    invoice,
    Invoice,
    PackingList,
    packingList,
    editadd,
    addresses,
    getAddress,
    deleteAddress,
    editAddress,
    orders,
    getOrders,
    users,
    getUsers,
    orderdetails,
    getOrderdetails,
    address,
    addAddress,
    st,
    getStates,
    zipcode,
    getZipcodes,
    getReOrderDetails,
    reOrderdetails,
    loader,
    downloadInvoice,
    queryAutocompleteForSuggestion,
    downloadStatement,
    downloadStatementLoader,
    getCreditCards,
    invoices,
    getInvoices,
    isInvoicesLoading,
  };
}
